module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"msg-title":"Bald verfügbar","msg-text":"Wir sind fast da!"},"fr":{"msg-title":"Bientôt disponible","msg-text":"Nous y sommes presque!"},"it":{"msg-title":"Disponibile a breve","msg-text":"Ci siamo quasi!"}}')
  delete Component.options._Ctor
}
